<template>
    <div class="indexApplyAll">
        <img src="../assets/images/bg.jpg" alt="" class="indexBG">
        <div class="indexNav">
            <div class="lastApply">
                <span></span>
                <label>最后一次申请</label>
                <span></span>
            </div>
            <div class="indexBtn">
                <img src="../assets/images/noPay.png" alt="">
                <div class="indexName">
                    <span>张三</span>
                    <span>微信住院邮寄</span>
                </div>
                <div class="indexLook">
                    <span>立即</span>
                    <span>查看</span>
                </div>
            </div>
            <div class="indexApply" @click="goToApply()">
                    <span>立即</span>
                    <span>申请</span>
            </div>
        </div>
        <div class="myApply">
            <span @click="goToMyOrder()">我的申请</span>
            <span>常见问题</span>
        </div>
    </div>
</template>
<script>
  import ApiSetting from '@/assets/js/api'
  export default {

    methods: {
      goToApply :function (event) {
        this.$router.push("/main");
      },
      goToMyOrder :function () {
        this.$router.push("/myOrder");
      }
    },

    mounted(){
      let code = this.$utils.getUrlKey("code");
      if (code !=undefined) {
        this.$http.get(ApiSetting.getOpenId + code).then((response) => {
        })
      }
    }

  }
</script>
<style lang="less" scoped>
    .indexApplyAll {
        background: #ffffff;
        height: 100%;
    }

    .indexBG {
        width: 100%;
        height: auto;
        display: block;
    }

    .indexNav {
        background: #d3f9ff;
        height: 4rem;
        position: relative;
    }

    .lastApply {
        width: 80%;
        margin-left: 10%;
        font-size: 0.32rem;
        color: #5ad5d3;
        text-align: center;
        padding: 0.4rem 0rem;
        span {
            width: 1rem;
            display: inline-block;
            border-top: 1px solid #5ad5d3;
            margin: 0.1rem 0.2rem;
        }
    }

    .indexBtn {
        font-size: 0.32rem;
        color: #ffffff;
        background: #5ad5d3;
        width: 90%;
        margin-left: 5%;
        border-radius: 0.7rem;
        height: 1.4rem;
        img {
            width: auto;
            height: 1.2rem;
            margin-left: 0.1rem;
            margin-top: 0.1rem;
            float: left;
        }
        .indexName {
            float: left;
            margin-top: 0.1rem;
            width: 3.7rem;
            text-align: center;
            font-size: 0.34rem;
            span {
                display: block;
                line-height: 0.6rem;
                margin-left: -0.2rem;
            }
        }
        .indexLook {
            float: right;
            background: #ffffff;
            height: 1.2rem;
            width: 1.2rem;
            color: #5ad5d3;
            border-radius: 0.6rem;
            margin-top: 0.1rem;
            margin-right: 0.1rem;
            text-align: center;
            span {
                display: block;
                line-height: 0.4rem;
            }
            span:first-child {
                margin-top: 0.2rem;
            }
        }
    }

    .indexApply {
        margin: 0 auto;
        font-size: 0.32rem;
        color: #ffffff;
        background: #5ad5d3;
        height: 1.2rem;
        width: 1.2rem;
        border-radius: 0.6rem;
        text-align: center;
        margin-top: 0.7rem;
        span {
            display: block;
            line-height: 0.4rem;
        }
        span:first-child {
            padding-top: 0.2rem;
        }
    }

    .myApply {
        font-size: 0.32rem;
        color: #050505;
        font-weight: 600;
        span {
            height: 0.8rem;
            line-height: 0.8rem;
            width: 50%;
            display: inline-block;
            text-align: center;
        }
    }
</style>
